/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiPublishSocialVersionContentMutationRequest, ContentAiPublishSocialVersionContentMutationResponse, ContentAiPublishSocialVersionContentPathParams, ContentAiPublishSocialVersionContent401, ContentAiPublishSocialVersionContent403 } from "../models/ContentAiPublishSocialVersionContent";

export function getContentAiPublishSocialVersionContentUrl(id: ContentAiPublishSocialVersionContentPathParams["id"], platform: ContentAiPublishSocialVersionContentPathParams["platform"]) {
  const res = { method: 'POST', url: `/content-ai/v1/contents/${id}/social-version/${platform}/publish` as const }
  return res
}

/**
 * @summary Publish social version to platform
 * {@link /content-ai/v1/contents/:id/social-version/:platform/publish}
 */
export async function contentAiPublishSocialVersionContent(id: ContentAiPublishSocialVersionContentPathParams["id"], platform: ContentAiPublishSocialVersionContentPathParams["platform"], data: ContentAiPublishSocialVersionContentMutationRequest, config: Partial<RequestConfig<ContentAiPublishSocialVersionContentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ContentAiPublishSocialVersionContentMutationResponse, ResponseErrorConfig<ContentAiPublishSocialVersionContent401 | ContentAiPublishSocialVersionContent403>, ContentAiPublishSocialVersionContentMutationRequest>({ method : "POST", url : getContentAiPublishSocialVersionContentUrl(id, platform).url.toString(), data : requestData, ... requestConfig })
  return res.data
}